import * as React from 'react';
const SvgLink = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      d="M18.533 5.464c-1.95-1.952-5.12-1.952-7.08 0l-1.77 1.77c-.2.2-.2.511 0 .711l.71.71c.2.2.51.2.71 0l1.77-1.77a3.01 3.01 0 0 1 4.25 0c1.18 1.17 1.17 3.072 0 4.252l-1.77 1.772c-.2.2-.2.51 0 .71l.71.71c.2.2.51.2.71 0l1.77-1.77c1.95-1.952 1.95-5.124 0-7.085z"
    />
    <path
      fill="currentColor"
      d="M7.923 14.71s-.06.09-.08.14c-.03.1-.03.21 0 .31.04.12.14.22.34.42l.29.29c.2.201.3.301.42.341.1.03.21.03.31 0 .11-.04.21-.14.41-.33l6.27-6.275c.11-.11.19-.19.25-.26.04-.05.07-.1.08-.15.02-.07.03-.14.02-.22 0-.03-.01-.06-.02-.09-.04-.12-.14-.22-.34-.42l-.29-.29c-.2-.2-.3-.3-.42-.34a.55.55 0 0 0-.31 0c-.11.04-.21.14-.41.33l-6.27 6.274c-.12.12-.2.2-.26.27z"
    />
    <path
      fill="currentColor"
      d="M13.613 15.35c-.2-.2-.51-.2-.71 0l-1.77 1.772a3.01 3.01 0 0 1-4.25 0 3.015 3.015 0 0 1 0-4.253l1.77-1.771c.2-.2.2-.51 0-.711l-.71-.71c-.2-.2-.51-.2-.71 0l-1.77 1.77c-1.95 1.952-1.95 5.124 0 7.086 1.95 1.961 5.12 1.951 7.08 0l1.77-1.771c.2-.2.2-.51 0-.711l-.71-.71z"
    />
  </svg>
);
export default SvgLink;
